module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-9-bb42fddfdf756d2aa3a224f7ac3215ac.webp";